import type { Transition } from "@uirouter/core";

import { swSettings } from "app/common/services/swSettings";
import { getLastMonthDuration, getLastWeekDuration } from "app/pages/benchmark-tracker/helpers/dateHelpers";
import { validateBenchmarkUrlParams } from "app/pages/benchmark-tracker/redirectHooks/validateBenchmarkUrlParams";
import { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";

import { DEFAULT_TAB } from "../constants/common";
import type { BenchmarkDataType } from "../types/api.types";
import type { BenchmarkUrlParams } from "../types/paramsTypes";

// Check url params and change them if needed
export const onRedirectToReport = () => async (transition: Transition) => {
    const toParams = transition.params("to") as BenchmarkUrlParams;
    // get benchmark from benchmarkResolver cache
    const currentBenchmark = await transition.injector().getAsync<BenchmarkDataType>("benchmark");

    if (!currentBenchmark) {
        return transition.router.stateService.target("activation-home");
    }

    const { key, country, granularity, webSource, duration, downloadPdf, tab } = toParams || {};
    const {
        isAllParamsValid,
        isCountryValid,
        isDurationValid,
        isGranularityValid,
        isTabValid,
        isValidDownloadPdf,
        isWebSourceValid,
    } = validateBenchmarkUrlParams({
        params: {
            country,
            duration,
            granularity,
            tab,
            webSource,
            downloadPdf,
        },
        validCountryList: swSettings.components.Activation.totalCountries,
    });

    if (!isAllParamsValid) {
        const validTab = isTabValid ? tab : DEFAULT_TAB;
        const validCountry = isCountryValid ? country : currentBenchmark.country;
        const validGranularity = isGranularityValid ? granularity : BenchmarkGranularity.WEEKLY;
        const validWebSource = isWebSourceValid ? webSource : "Total";

        const validDuration = isDurationValid
            ? duration
            : validGranularity === BenchmarkGranularity.WEEKLY
              ? getLastWeekDuration()
              : getLastMonthDuration();

        const validDownloadPdf = isValidDownloadPdf ? downloadPdf : "0";

        const params = {
            country: validCountry,
            downloadPdf: validDownloadPdf,
            duration: validDuration,
            granularity: validGranularity,
            tab: validTab,
            key,
            webSource: validWebSource,
            isDurationChanged: !isDurationValid,
        };

        return { params };
    }
};
